import { cn } from "@/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** "pulse" (default) usa animate-pulse; "shimmer" exibe faixa de brilho deslizante. */
  variant?: "pulse" | "shimmer";
}

function Skeleton({ className, variant = "pulse", ...props }: SkeletonProps) {
  if (variant === "shimmer") {
    return (
      <div
        className={cn("relative overflow-hidden rounded-md bg-muted", className)}
        {...props}
      >
        <span className="absolute inset-0 -translate-x-full animate-shimmer bg-linear-to-r from-transparent via-white/60 to-transparent" />
      </div>
    );
  }

  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
